window.customLocalStorage=
{
    getItem(key)
    {
        let result=JSON.parse(window.localStorage.getItem(key));

        if(result)
        {
 
            if(result.expireTime<=Date.now())
            {
                window.localStorage.removeItem(key);
                return null;
            }
            return result.data;
        }
        return null;
    },

    setItem(key, value, maxAge=30*30*60*1000)
    {
        let result=
        {
            data:value
        }

        if(maxAge)
        {
            result.expireTime=Date.now()+maxAge;
        }
        window.localStorage.setItem(key,JSON.stringify(result));
    },
    removeItem(key)
    {
        window.localStorage.removeItem(key);
    },
    clear()
    {
        window.localStorage.clear();
    }
}


$("#listable-container").addClass('container');
function removeParam(parameter)
{
  var url=document.location.href;
  var urlparts= url.split('?');

 if (urlparts.length>=2)
 {
  var urlBase=urlparts.shift(); 
  var queryString=urlparts.join("?"); 

  var prefix = encodeURIComponent(parameter)+'=';
  var pars = queryString.split(/[&;]/g);
  for (var i= pars.length; i-->0;)               
      if (pars[i].lastIndexOf(prefix, 0)!==-1)   
          pars.splice(i, 1);
  url = urlBase+'?'+pars.join('&');
  window.history.pushState('',document.title,url); // added this line to push the new url directly to url bar .

}
return url;
}

function downloadImage(url, name){
  $('body').removeClass('loaded');
      fetch(url)
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = name;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          $('body').addClass('loaded');
        })
        .catch(() => alert('An error sorry'));
}


// var sliderbtuMap = $('#btu_total_rang').val().split(",");
// var url = new URL(location.href);
// var btu_min = url.searchParams.get("btu_min");
// var btu_max = url.searchParams.get("btu_max");
// var indexbtu1 = sliderbtuMap.indexOf(btu_min);
// var indexbtu2 = sliderbtuMap.indexOf(btu_max);
// if(indexbtu2 == '-1' ){
//  var indexbtu2 =  sliderbtuMap.length-1;
// }
// $(function() {

// 	$( "#btu-range" ).slider({
// 		range: true,
// 		min: 0,
// 		max: sliderbtuMap.length-1,
// 		values: [indexbtu1, indexbtu2],
// 		slide: function( event, ui ) {
//           var queryString = window.location.search;
//           var queryString = removeParam("btu_min", queryString);
//           var queryString = removeParam("btu_max", queryString);
//           var queryString = removeParam("filter.p.tag", queryString);
//           var btu_query = "";
// 			$( "#from_btu" ).html( sliderbtuMap[ui.values[ 0 ]] );
// 			$( "#to_btu" ).html( sliderbtuMap[ui.values[ 1 ]]);         
//              var first_val = ui.values[ 0 ];
//              var sc_val = ui.values[ 1 ];
//              var btu_rangeArray = sliderbtuMap.slice(first_val, sc_val+1);
//               var btu_max = btu_rangeArray.length;
       
//           for (var i = 0; i < btu_rangeArray.length; i++) {           
//          btu_query += "" + encodeURIComponent(btu_rangeArray[i]);          
//          if (i < btu_rangeArray.length) { btu_query += ","; }             
//          }


// var queryString = queryString.replace('?', ''); 
// var queryString = queryString.replace('&&', '&'); 
// // const urlParams = new URL(queryString);         
// // var queryString = urlParams.set("btu_min", sliderbtuMap[ui.values[ 0 ]]);
// // var queryString = urlParams.set("btu_max", sliderbtuMap[ui.values[ 1 ]]);
// // var queryString = urlParams.set("filter.p.tag", btu_query);
// // var btu_url = queryString;  
// // console.log(urlParams);
// var btu_url = location.pathname + '?btu_min='+sliderbtuMap[ui.values[ 0 ]]+'&btu_max='+sliderbtuMap[ui.values[ 1 ]]+'&filter.p.tag=' + btu_query + '&' + queryString;

          
          
// $('.capi_rang_url').attr('href', btu_url);
// $('.capi_rang_url').click();
// 		}
// 	});
//     $("#from_btu").html(sliderbtuMap[$("#btu-range").slider("values", 0)]);
//     $("#to_btu").html(sliderbtuMap[$("#btu-range").slider("values", 1)]);
// 	$("#from_btu").change(function() {
//     	$("#btu-range").slider('values',0,$(this).html());
//     });
// 	$("#to_btu").change(function() {
// 	    $("#btu-range").slider('values',1,$(this).html());     
// 	});

// });




// *********************************************************************************************************************************************************
if ($('#btu_total_rang').val() != null){
var sliderbtuMap = $('#btu_total_rang').val().split(",");

var btuurl = new URL(location.href);
var btu_min = btuurl.searchParams.get("btu_min");
var btu_max = btuurl.searchParams.get("btu_max");
if(btu_max == null || btu_min == null ){
 var btu_min = 0;
 var btu_max =  sliderbtuMap.length-1;
}
$('.btu_range_active span').html(sliderbtuMap[btu_min] +' - '+ sliderbtuMap[btu_max]);
$(function() {

	$( "#btu-range" ).slider({
		range: true,
		min: 0,
		max: sliderbtuMap.length-1,
		values: [btu_min, btu_max],
		slide: function( event, ui ) {
            var btu_queryString = window.location.search;
            var btu_queryString = removeParam("btu_min", btu_queryString);
            var btu_queryString = removeParam("btu_max", btu_queryString);
            var btu_queryString = removeParam("filter.p.tag", btu_queryString);
            var f_value = sliderbtuMap[ui.values[ 0 ]];
            var to_value = sliderbtuMap[ui.values[ 1 ]];
             var query = "";
			$( "#from_btu" ).html(f_value);
			$( "#to_btu" ).html(to_value);         
             var first_val = ui.values[ 0 ];
             var sc_val = ui.values[ 1 ];
             var rangeArray = sliderbtuMap.slice(first_val, sc_val+1);
              var btu_max = rangeArray.length;
          for (var i = 0; i < rangeArray.length; i++) {
          query += "" + encodeURIComponent(rangeArray[i]);    
         if (i < rangeArray.length - 1) { query += ","; }
          }

var btuindex1 = sliderbtuMap.indexOf(f_value);
var btuindex2 = sliderbtuMap.indexOf(to_value);   
//var btu_queryString = btu_queryString.replace('?', '');
 if(btuindex1 == '0' & btuindex2 == sliderbtuMap.length-1 ){
var btuurl = btu_queryString;  
    }  else {     


const bturl = new URL(btu_queryString);
bturl.searchParams.set('btu_min', btuindex1);
bturl.searchParams.set('btu_max', btuindex2);
var btuurl = bturl.search;   
var btuurl = btuurl+'&filter.p.tag=' + query;
   
}        
$('.capi_rang_url').attr('href', btuurl);
$('.capi_rang_url').click();
 setTimeout(function() {
$('.btu_range_active span').html(sliderbtuMap[$("#btu-range").slider("values", 0)] +' - '+ sliderbtuMap[$("#btu-range").slider("values", 1)]);    
  }, 2500);
        }
	});
    $("#from_btu").html(sliderbtuMap[$("#btu-range").slider("values", 0)]);
    $("#to_btu").html(sliderbtuMap[$("#btu-range").slider("values", 1)]);
	$("#from_btu_inpu").change(function() {
    	$("#btu-range").slider('values',0,$(this).html());
    });
	$("#to_btu").change(function() {
	    $("#btu-range").slider('values',1,$(this).html()); 
      
	});

});


$( document ).on( "click", ".btu_range_active", function() {  
  var btu_queryString = window.location.search;
  var btu_queryString = removeParam("btu_min", btu_queryString);
  var btu_queryString = removeParam("btu_max", btu_queryString);
  var btu_queryString = removeParam("filter.p.tag", btu_queryString);
  window.location.href = btu_queryString;
});
  
}




// *********************************************************************************************************************************************************
if ($('#capcity_total_rang').val() != null){
var sliderAmountMap = $('#capcity_total_rang').val().split(",");
var url = new URL(location.href);
var capi_min = url.searchParams.get("capi_min");
var capi_max = url.searchParams.get("capi_max");
console.log(capi_max);
if(capi_max == null || capi_min == null ){
 var capi_min = 0;
 var capi_max =  sliderAmountMap.length-1;
}
$('.capacity_range_active span').html(sliderAmountMap[capi_min] +' - '+ sliderAmountMap[capi_max]);
$(function() {

	$( "#capacity-range" ).slider({
		range: true,
		min: 0,
		max: sliderAmountMap.length-1,
		values: [capi_min, capi_max],
		slide: function( event, ui ) {
            var capi_queryString = window.location.search;
            var capi_queryString = removeParam("capi_min", capi_queryString);
            var capi_queryString = removeParam("capi_max", capi_queryString);
            var capi_queryString = removeParam("filter.p.m.NominalCapacity.NominalCapacity", capi_queryString);
            var f_value = sliderAmountMap[ui.values[ 0 ]];
            var to_value = sliderAmountMap[ui.values[ 1 ]];
             var query = "";
			$( "#from_capi" ).html(f_value);
			$( "#to_capi" ).html(to_value);         
             var first_val = ui.values[ 0 ];
             var sc_val = ui.values[ 1 ];
             var rangeArray = sliderAmountMap.slice(first_val, sc_val+1);
              var capi_max = rangeArray.length;
          for (var i = 0; i < rangeArray.length; i++) {
          query += "" + encodeURIComponent(rangeArray[i]);    
         if (i < rangeArray.length - 1) { query += ","; }
          }

var index1 = sliderAmountMap.indexOf(f_value);
var index2 = sliderAmountMap.indexOf(to_value);   
if(index1 == '0' & index2 == sliderAmountMap.length-1 ){
var url = capi_queryString;  
    }  else {     

const cpurl = new URL(capi_queryString);
cpurl.searchParams.set('capi_min', index1);
cpurl.searchParams.set('capi_max', index2);
var queryString = cpurl.search;    
var url = queryString+'&filter.p.m.NominalCapacity.NominalCapacity=' + query;
 }
           
$('.capi_rang_url').attr('href', url);
$('.capi_rang_url').click();
 setTimeout(function() {
$('.capacity_range_active span').html(sliderAmountMap[$("#capacity-range").slider("values", 0)] +' - '+ sliderAmountMap[$("#capacity-range").slider("values", 1)]);    
  }, 2500);
        }
	});
    $("#from_capi").html(sliderAmountMap[$("#capacity-range").slider("values", 0)]);
    $("#to_capi").html(sliderAmountMap[$("#capacity-range").slider("values", 1)]);
	$("#from_capi_inpu").change(function() {
    	$("#capacity-range").slider('values',0,$(this).html());
    });
	$("#to_capi").change(function() {
	    $("#capacity-range").slider('values',1,$(this).html()); 
      
	});

});


$( document ).on( "click", ".grand_child_nav > a", function() {  
$(this).parent().toggleClass('open');
$(this).parent().find('.grandchild').slideToggle();
});

  
// $( document ).on( "click", ".fillter_search", function() {  
//   var capi_min = $('.s_capi_min').attr('value');
//   var capi_max = $('.s_capi_max').attr('value');
//   var s_capi_values = $('.s_capi_values').attr('value');
//   var p_pr_min = $('.pr_min').attr('data-value');
//   var pr_min = p_pr_min.slice(0, -2);
//   var p_pr_max = $('.pr_max').attr('data-value');
//   var pr_max = p_pr_max.slice(0, -2);

//   var filltes_by = '';
//   $('.fillter_ul a.active').each(function () {
//     var this_name_val = $(this).attr('data-name');
//     var this_val = $(this).attr('data-value');
//     filltes_by += '&'+this_name_val+'='+this_val;
//  });
  
//   window.location.href = '/collections/parts?filter.v.price.gte='+pr_min+'&filter.v.price.lte='+pr_max+'&capi_min='+capi_min+'&capi_max='+capi_max+'&filter.p.m.NominalCapacity.NominalCapacity='+s_capi_values+filltes_by;
// });
$( document ).on( "click", ".capacity_range_active", function() {  
  var rcapi_queryString = window.location.search;
  var rcapi_queryString = removeParam("capi_min", rcapi_queryString);
  var rcapi_queryString = removeParam("capi_max", rcapi_queryString);
  var rcapi_queryString = removeParam("filter.p.m.NominalCapacity.NominalCapacity", rcapi_queryString);
  console.log(rcapi_queryString);
  window.location.href = rcapi_queryString;
});

}
// *********************************************************************************************************************************************************

(function($){
    $(document).ready(function(e){      
      var url = new URL(location.href);
      var params = new URLSearchParams(url.search);
      var qsearch = params.get('q');
      if ( qsearch != null ) {  
     var value = qsearch;
  var patt = new RegExp(value, "i");

//   $('.tt-product-listing').find('.tt-col-item').each(function() {
//     var $table = $(this);
    
//     if (($table.find('.tt-title').text().search(patt) >= 0)) {
//       $(this).show();
//     } else {
// $(this).hide();      
//     }
    
//   });
        $('.knowledge-base-search').val(qsearch);
      }

/////////////////////////////////////////////////////////////////////////////////////
      
$('select.sort-position.order').on('change', function() {
  //alert(  );
  window.location.replace("../pages/order-history?sort_by="+this.value);
});
      
      
});
})(jQuery);
$('.knowledge-base-search').on('keyup', function() {
//  alert();
  var value = $(this).val();
  var patt = new RegExp(value, "i");

  $('.tt-product-listing').find('.tt-col-item').each(function() {
    var $table = $(this);
    
    if (($table.find('.tt-title').text().search(patt) >= 0)) {
      $(this).show();
    } else {
$(this).hide();      
    }
    
  });
 
});
$('#address_country_new option').eq(0).attr("value", "");
$('#address_country_new option').eq(0).attr("disabled", "true");



jQuery( ".js-deleteitem-ajax_new" ).on( "click", function(e) {
  var variant_id = $(this).attr('data-item_id');
  var this_tr = $(this).parents('tr').attr('data-item');
   var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity=0&id='+variant_id,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                //Shopify.onCartUpdate(cart);
              var car_item = cart.item_count;
              $('tr[data-item="'+this_tr+'"').remove();
              $('#subtotal td').html(getItemFormatedPrice(cart.items_subtotal_price)); 
             if(car_item < 1 ) {
               $('.line-items-box-js').addClass('hide');
               $('.tt-empty-cart-js').removeClass('hide');
               $('.tt-empty-cart-js').html('<div class="tt-empty-cart"><span class="tt-icon icon-f-39"></span><h1 class="tt-title">SHOPPING CART IS EMPTY</h1><p>You have no items in your shopping cart.</p><a href="/collections/all" class="btn ttbtnmainstyle">CONTINUE SHOPPING</a></div>');
            
             }
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            // console.log(XMLHttpRequest.responseJSON.message);
            if (XMLHttpRequest.responseJSON.message == 'nu există un id valid sau parametru de linie' || XMLHttpRequest.responseJSON.message == 'Required parameter missing or invalid: line or id param is required' || XMLHttpRequest.responseJSON.message == 'Parameter Missing or Invalid' || XMLHttpRequest.responseJSON.message == 'no valid id or line parameter') {
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data:  'quantity=0&id='+variant_id.split(':')[0],
                    dataType: 'json',
                    success: function(cart) {
                        if ((typeof callback) === 'function') {
                            callback(cart);
                        } else {
                            //Shopify.onCartUpdate(cart);
                          alert('Something went wrong!');
                        }
                    }
                })
            } else {
                Shopify.onError(XMLHttpRequest, textStatus);
            }
        }
    };
    $.ajax(params);
});

jQuery( ".btn-quantity" ).on( "click", function(e) {
var this_item_price = $(this).parents('.line_item_tr').find('.item__original-price').html();
var this_item_src_price = $(this).parents('.line_item_tr').find('.srp_price');
var updating_row = $(this).parents('.line_item_tr').addClass('updating_item');
var variant_id = $(this).attr('data-item_id');  
var prv_quantity = $(this).parent().find('.cart-item-qty-input').val();
if ($(this).hasClass("minus")) {
if(prv_quantity == '1') {
  var quantity = 1;
} else {
var quantity = parseFloat(prv_quantity) - 1;
}
} else {
  var quantity = parseFloat(prv_quantity) + 1;
}
$(this).parent().find('.cart-item-qty-input').val(quantity);

  var src_price = parseFloat(this_item_price); 
  
  var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity='+quantity+'&id='+variant_id,
        dataType: 'json',
        success: function(cart) {
          $('.line_item_tr').removeClass('updating_item');
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                //Shopify.onCartUpdate(cart);
              console.log(cart);
              $('#subtotal td').html(getItemFormatedPrice(cart.original_total_price));
              $('#grandtotal td').html(getItemFormatedPrice(cart.total_price));
              $('#total_discount td').html(getItemFormatedPrice('-'+cart.total_discount)); 
              jQuery.each(cart.items, function(index, abc) {
                id = abc.id;
                price = abc.price;
                quantity = abc.quantity;
                sku = abc.sku;
                variant_id = abc.variant_id;
                product_id = abc.product_id;
                product_type = abc.product_type;
                final_price = abc.line_price;
                data = [id, product_id, price, quantity, sku, variant_id, product_type];
                var s_price = price*quantity;
                var srp_price = getItemFormatedPrice(s_price);
                var final_price = getItemFormatedPrice(final_price);
                $('[data-item="'+sku+'"]').find('.srp_price').find('.subtotal').html(srp_price);
                $('[data-item="'+sku+'"]').find('.net_subtotal').find('.subtotal').html(final_price);
                $('[data-item="'+sku+'"]').find('.net_subtotal').find('.subtotal.tt-price-old').html(srp_price);
                
            });
            
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            // console.log(XMLHttpRequest.responseJSON.message);
            if (XMLHttpRequest.responseJSON.message == 'nu există un id valid sau parametru de linie' || XMLHttpRequest.responseJSON.message == 'Required parameter missing or invalid: line or id param is required' || XMLHttpRequest.responseJSON.message == 'Parameter Missing or Invalid' || XMLHttpRequest.responseJSON.message == 'no valid id or line parameter') {
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data:  'quantity='+quantity+'&id='+variant_id.split(':')[0],
                    dataType: 'json',
                    success: function(cart) {
                        if ((typeof callback) === 'function') {
                            callback(cart);
                        } else {
                            //Shopify.onCartUpdate(cart);
                        }
                    }
                })
            } else {
                Shopify.onError(XMLHttpRequest, textStatus);
            }
        }
    };
    $.ajax(params);
}); 

jQuery( ".plus-btn" ).on( "click", function(e) {
  var q_val = $(this).parent('.tt-input-counter').find('input[name="quantity"]').val();
  var q_size = $(this).parent('.tt-input-counter').find('input[name="quantity"]').attr('size');
  if(q_val == q_size){
    $('#modalreached_max').modal('show');
    $('#modalforTrade').addClass('hide');
  }
});


jQuery(document).on('hide.bs.modal','#modalreached_max', function (){
   jQuery('#modalforTrade').removeClass('hide');
});

function added_to_cart() {
 setTimeout(function () {    
   $('#modalAddToCartProduct').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').addClass('hide').removeClass('show');
  }, 10 );
  setTimeout(function () { 
  $(".custom-loader").hide();
  $('.alert-success').addClass('show');
  $('.alert-success').find('.msg_info').text('Successfully added to Cart');
  $('.alert-success').find('.btn_info').html('<a href="/cart">View Cart</a>');
     
   }, 500);
  setTimeout(function () { 
  $('.alert-success').removeClass('show');
   }, 5000); 
}




Shopify.onItemAdded = function(line_item) {
    console.log('line_item'+line_item);
    added_to_cart();

     Shopify.getCart();
   // console.log(line_item);
   addToCartHandler.addItem(line_item);
    addedModal.initSingleItem(line_item);
  
     setTimeout(function () {    
     $('#modalAddToCartProduct').modal('hide');
      $('body').removeClass('modal-open');
      $('.modal-backdrop').addClass('hide').removeClass('show');
    }, 1000 );
  
}

jQuery(document).on('show.bs.modal','#modalAddToCartError', function (){
   $(".custom-loader").hide();
});

jQuery(document).on('hide.bs.modal','#modalAddToCartError', function (){
if ($("#modalforTrade").hasClass("reopen")) {
   $("#modalforTrade").removeClass("reopen");
   $("#modalforTrade").modal("show");
  setTimeout(function () { 
   $('body').addClass('modal-open');
    }, 500); 
}  
});


jQuery( ".login_btn" ).on( "click", function(e) {
  jQuery("#login").click();
});

jQuery('#faq_topics').change(function() {
    var val = jQuery("#faq_topics option:selected").val();
    jQuery('.faq_side_content').find('.tt-collapse').removeClass('open');
    jQuery('.faq_side_content').find('.tt-collapse-content').hide();
    jQuery('html, body').animate({
    'scrollTop':   $('#'+val).offset().top - 20 }, 500);
    jQuery('#'+val).next('.tt-collapse').find('.tt-collapse-title').click();
  
});

jQuery("li.dropdown.tt-megamenu-col-02.submenuarrow.tt-submenu").hover(function(){
    $('body').addClass("menu_hoverd");
    }, function(){
    $('body').removeClass("menu_hoverd");
  });

jQuery( ".tt-faqitem_title" ).on( "click", function(e) {
  var fqname = jQuery(this).attr('data-fqname');
  jQuery(".faq_side_bar").find('li').removeClass('active');
  jQuery(this).parent().addClass('active');

  jQuery('.faq_side_content').find('.tt-collapse').removeClass('open');
  jQuery('.faq_side_content').find('.tt-collapse-content').hide();
  jQuery('#'+fqname).next('.tt-collapse').find('.tt-collapse-title').click();
});

jQuery( ".tt-dropdown-outer .tt-dropdown-toggle" ).on( "click", function(e) {
  $(this).parent('.tt-dropdown-outer').find('.tt-dropdown').slideToggle();
});



jQuery(".tt-menu-toggle").on("click", function(e) {
  e.preventDefault();
  $('nav.mobile-main-menu').addClass('open');
});
jQuery(".mob-menu-close").on("click", function(e) {
  e.preventDefault();
  $('nav.mobile-main-menu').removeClass('open');
});
jQuery(".toggle_nav .link_m").on("click", function(e) {
  e.preventDefault();
  $(this).parent('.toggle_nav').toggleClass('open');
  $(this).parent('.toggle_nav').find('.sub_l_1').slideToggle();
});
jQuery(".login").on("click", function(e) {
  e.preventDefault();
  $("#login").click();
});
jQuery(".logout").on("click", function(e) {
  e.preventDefault();
  $("#logout").click();
});
jQuery(".fillter_ul li a").on("click", function(e) {
e.preventDefault();
$(this).toggleClass('active');
});
jQuery(".fillter_search").on("click", function(e) {
e.preventDefault();
 $(".custom-loader").show();
if($('.instock_f').hasClass("active") && $('.outstock_f').hasClass("active")){
window.location.href = '/collections/parts';  
   $(".custom-loader").hide();
} else if($('.instock_f').hasClass("active") && !$('.outstock_f').hasClass("active")){
 window.location.href = '/collections/in-stock'; 
   $(".custom-loader").hide();
} else if(!$('.instock_f').hasClass("active") && $('.outstock_f').hasClass("active")){
 window.location.href = '/collections/out-of-stock'; 
   $(".custom-loader").hide();
} else {
   $(".custom-loader").hide();
}
  
});

$( document ).on( "click", ".shopifyfiltres-js li.active", function() {  
  var this_name = $(this).attr('data-fname');
  setTimeout(function () {
  $('.clear-filters .'+this_name+ ' a').click();
    }, 500);
 //alert(this_name);
});

$( document ).on( "click", ".filtres-js li.active", function() {  
  var this_name = $(this).attr('data-fname');
  setTimeout(function () {
  $('.clear-filters .'+this_name+ ' a').click();
    }, 500);
 //alert(this_name);
});


$(document).ready(function() {
  
  var section = document.querySelectorAll(".faq_list");
  var sections = {};
  var i = 0;

  Array.prototype.forEach.call(section, function (e) {
      sections[e.id] = e.offsetTop;
  });

  window.onscroll = function () {
      var scrollPosition = document.documentElement.scrollTop;

      for (i in sections) {
          if (sections[i] <= scrollPosition) {
            //alert(i);
              $('.faq_nme').parent().removeClass('active');
              document.querySelector('li[id*=fq_' + i + ']').setAttribute('class', 'active');
          }
      }
  };		
});

$(document).mouseup(function(e) 
{
    var container = $(".tt-dropdown");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.slideUp();
    }
});


$(document).on("click", ".copy_link", function() {
    var Url = $(this).attr('data-copy_value');
    
    // Create a temporary textarea element to select and copy the text
    var tempInput = $("<textarea>");
    $("body").append(tempInput);
    tempInput.val(Url).select();
    
    try {
        document.execCommand("copy");
        $(this).find('.tooltiptext').html('Copied!');
    } catch (err) {
        console.error('Failed to copy text:', err);
    }
    
    // Remove the temporary textarea
    tempInput.remove();
});
  function resetTooltip() {
    $('.tooltiptext').html('Copy Link');
  }

const one_minute = 60000; 
const cookieNoticeTimeout = 1; // Default to 30 days if not set
const cookieNoticeStatus = customLocalStorage.getItem('cookie_notice_status');
console.log('notice'+cookieNoticeStatus);
if(cookieNoticeStatus !== 'hide'){
   setTimeout(function() { 
     $('.cookie_notice').slideDown(); // Smoothly show the notice
   }, 5000);
} 

$(document).on("click", ".cookie_accept", function() {
  customLocalStorage.setItem('cookie_notice_status', 'hide', one_minute * 60 * 24 * cookieNoticeTimeout);
  $('.cookie_notice').slideUp(); 
});

//customLocalStorage.setItem('cookie_notice_status', '', one_minute*60*24*cookieNoticeTimeout);

$(document).ready(function(){
$('form input[minlength], form textarea[minlength]').on('keydown', function(){
    var e_len = $(this).val().trim().length;
    var e_min_len = Number($(this).attr('minlength'));
    var message = e_min_len-1 <= e_len ? '' : e_min_len + ' characters minimum';
    this.setCustomValidity(message);
    //this.reportValidity();  // Forces the browser to display the message immediately.
});

});

